import React from 'react';
export var DefaultCardArtV2 = _ref => {
  var {
    title
  } = _ref;
  return React.createElement("svg", {
    "aria-labelledby": "default-card-art-title",
    "data-testid": "default-card-art",
    fill: "currentColor",
    height: "38",
    role: "img",
    viewBox: "0 0 24 24",
    width: "38",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("title", {
    id: "default-card-art-title"
  }, title), React.createElement("path", {
    d: "M20 5H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zM7.5 9.2c0 .44-.36.8-.8.8H5.3c-.44 0-.8-.36-.8-.8V7.8c0-.44.36-.8.8-.8h1.4c.44 0 .8.36.8.8v1.4zm7.99 6.29c-.13.13-.29.19-.46.19-.17 0-.33-.06-.46-.19a.658.658 0 0 1 0-.92c.67-.67.67-1.76 0-2.42a.658.658 0 0 1 0-.92c.25-.25.67-.25.92 0a3.006 3.006 0 0 1 0 4.26zm2.71 1.3c-.13.13-.29.19-.46.19-.17 0-.33-.06-.46-.19a.658.658 0 0 1 0-.92 3.549 3.549 0 0 0 0-5.01.658.658 0 0 1 0-.92c.25-.25.67-.25.92 0 1.89 1.88 1.89 4.96 0 6.85z"
  }));
};
export default DefaultCardArtV2;